export default __webpack_public_path__ + "static/media/2010.13d8d0cc.png";